import React from 'react';
import { useMediaQuery } from '@mui/material';
import { MessageSquareText } from 'lucide-react';

// Step "Mensajes"
const Step3Icon = ({ color }) => {
    const matches = useMediaQuery('(min-width:600px)');
    return <MessageSquareText color={color} size={matches ? 25 : 20} strokeWidth={2.1} />;
};

export default Step3Icon;
